import styled from "@emotion/styled";
import { IconProps } from "./Icon.types";
import { getColor } from "../../theme/theme";

export const IconWrapper = styled.div<
  Pick<
    IconProps,
    | "height"
    | "width"
    | "size"
    | "color"
    | "bgColor"
    | "borderRadius"
    | "cursor"
  >
>`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: ${(props) => props.width || "28"}px;
  height: ${(props) => props.height || "28"}px;
  font-size: ${(props) => props.size || "24"}px;
  color: ${(props) => getColor(props.color || "black")};
  background-color: ${(props) => getColor(props.bgColor || "transparent")};
  border-radius: ${(props) => props.borderRadius ?? "0"};
  cursor: ${(props) => props.cursor || "default"};
  position: relative;
`;
